import { Axios } from "./Axios";

export const fetchServices = async (limit, offset, deliveryType) => {
  return await Axios.get(
    `/services/list?delivery_type_id=${
      deliveryType == 1 ||
      deliveryType == 2 ||
      deliveryType == 3 ||
      !deliveryType
        ? 0
        : deliveryType
    }`
  );
};
export const fetchCategories = async () => {
  return await Axios.get(`/laundry-item-category/list`);
};
export const fetchLaundryItem = async ({
  serviceId,
  categoryId,
  limit,
  offset,
}, signal) => {
  return await Axios.get(
    `/laundry-item/list/service/${serviceId}/category/${categoryId}?limit=${limit}&offset=${offset}`,
    {signal}
  );
};
export const fetchDeliveryType = async (limit, offset) => {
  return await Axios.get(`/laundry-delivery-type/list`);
};
export const fetchDeliveryTypeStore = async (limit, offset) => {
  return await Axios.get(`store/laundry-delivery-type/list`);
};
export const createOrder = async (payload) => {
  return await Axios.post("/customer/laundry/order/submit", payload, {
    responseType: "json",
  });
};
export const createRecurringOrder = async (payload) => {
  return await Axios.post("v2/customer/laundry/order/recurring", payload, {
    responseType: "json",
  });
};
export const calculateBundleOffer = ({
  totalQuantity,
  bundleBuy,
  bundleFree,
  itemPrice,
}) => {
  if (bundleBuy <= 0 || itemPrice < 0) {
    throw new Error("Invalid bundle or item price");
  }

  const bundleSize = bundleBuy + bundleFree;

  // Full bundles
  const completeBundles = Math.floor(totalQuantity / bundleSize);
  const remainingItems = totalQuantity % bundleSize;

  let boughtItems = completeBundles * bundleBuy;
  let freeItems = completeBundles * bundleFree;

  if (remainingItems > 0) {
    if (remainingItems < bundleBuy) {
      // Not enough to activate bundle -> normal price
      boughtItems += remainingItems;
    } else {
      // Bundle active once we reach >= bundleBuy
      boughtItems += bundleBuy;
      freeItems += remainingItems - bundleBuy;
    }
  }

  const totalPrice = boughtItems * itemPrice;

  return {
    totalItems: totalQuantity,
    freeItems,
    boughtItems,
    totalPrice,
  };
};

export const getBundleMessage = (e) => {
  return (({ quantity, bundle_buy, bundle_free }) => {
    if (bundle_buy <= 0 || bundle_free < 0) {
      return "Invalid bundle settings.";
    }

    const bundleSize = bundle_buy + bundle_free;

    // 1. Initial promo until minimum buy is reached
    if (quantity < bundle_buy) {
      return `Buy ${bundle_buy}, Get ${bundle_free} Free`;
    }

    const fullBundles = Math.floor(quantity / bundleSize);
    const remainder = quantity % bundleSize;
    const unlockedFreeItems = fullBundles;

    // 2. If remainder is less than bundle_buy → still in successful bundle zone
    if (remainder < bundle_buy) {
      return "Bundle availed successfully.";
    }

    // 3. Else, they started buying into the next bundle
    const itemsToNextBundle = bundleSize - remainder;
    return `You have unlocked ${
      unlockedFreeItems * bundle_free + bundle_free
    } free item${
      unlockedFreeItems + 1 > 1 ? "s" : ""
    }, add ${itemsToNextBundle} more`;
  })(e);
};
